exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.post-intro[data-v-34403384] {\n  height: 1px;\n  width: 500px;\n  min-width: 95%;\n  position: absolute;\n  top: 4rem;\n  right: 0;\n}\n", ""]);

// exports
